import React from "react";
import {bool} from "prop-types";
import {makeStyles, DialogContent, Typography, Grid} from "@material-ui/core";
import {CustomButton} from "@hapinest/theme";
import {useI18N} from "../../../common/common";
import {useKeycloakFunctions} from "../../../hooks/useKeycloakFunctions";
import NoIndexDialog from "../noIndex/NoIndexDialog";

const useStyles = makeStyles(theme => ({
    wrapper: {
        textAlign: "center",
        padding: theme.spacing(3)
    },
    expiredImg: {
        width: "80px",
        height: "80px",
        marginBottom: theme.spacing(3)
    },
    messageLabel: {
        marginTop: theme.spacing(5),
        marginBottom: theme.spacing(4)
    },
}));

const IdleDialog = ({isPrivateRoute}) => {
    const classes = useStyles();
    const {i18n} = useI18N();
    const {login} = useKeycloakFunctions();

    const handleSignIn = () => {
        login();
    };

    const handleContinue = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete("displayIdleDialog");
        location.href = url.href;
    };

    return (
        <NoIndexDialog
            aria-labelledby="customized-dialog-title"
            open
        >
            <DialogContent
                classes={{root: classes.wrapper}}
            >
                <img
                    src={"/images/session-expired.svg"}
                    alt="Session expired"
                    className={classes.expiredImg}
                />
                <Typography
                    variant="h4"
                >
                    {i18n("dialog.idle.session_expired")}
                </Typography>

                <Typography
                    variant="body1"
                    className={classes.messageLabel}
                >
                    {isPrivateRoute ? i18n("dialog.idle.message") : i18n("dialog.idle.message_public")}
                </Typography>

                {isPrivateRoute ? (
                    <CustomButton
                        variant="contained"
                        disableElevation
                        onClick={handleSignIn}
                    >
                        {i18n("dialog.idle.sign_again")}
                    </CustomButton>
                ) : (
                    <Grid
                        container
                        spacing={2}
                        direction="row-reverse"
                    >
                        <Grid
                            item
                            xs={12}
                            sm={6}
                        >
                            <CustomButton
                                variant="contained"
                                disableElevation
                                onClick={handleSignIn}
                                fullWidth
                            >
                                {i18n("dialog.idle.sign_again")}
                            </CustomButton>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={6}
                        >
                            <CustomButton
                                variant="outlined"
                                color="black"
                                disableElevation
                                onClick={handleContinue}
                                fullWidth
                            >
                                {i18n("dialog.idle.continue_as_visitor")}
                            </CustomButton>
                        </Grid>
                    </Grid>
                )}
            </DialogContent>
        </NoIndexDialog>
    );
};

IdleDialog.propTypes = {
    isPrivateRoute: bool
};

export default IdleDialog;
